export default "__VITE_ASSET__4nlTTQYs__"